class ProductFilter {
    constructor(productTypeData, purityData, collectionTypeData, addedProducts, getFieldValue) {
      this.productTypeData = productTypeData;
      this.purityData = purityData;
      this.collectionTypeData = collectionTypeData;
      this.addedProducts = addedProducts;
      this.getFieldValue = getFieldValue;
    }
  
    filterProducts(place, rowIndex) {
      return this.productTypeData.filter((product) => {
        if (place === "grid") {
          const categoryField = this.addedProducts[rowIndex]?.CategoryId;
          return product.CategoryId == categoryField;
        } else {
          const categoryField = this.getFieldValue("CategoryId", 'middle');
          console.log('checking catfieldvalue ', categoryField);
          
          return product.CategoryId == categoryField;
        }
      });
    }
  
    filterPurity(place, rowIndex) {
      return this.purityData.filter((product) => {
        if (place === "grid") {
          const categoryField = this.addedProducts[rowIndex]?.CategoryId;
          return product.CategoryId == categoryField;
        } else {
          const categoryField = this.getFieldValue("CategoryId", 'middle');
          return product.CategoryId == categoryField;
        }
      });
    }
  
    filterDesigns(place, rowIndex) {
      return this.collectionTypeData.filter((product) => {
        if (place === "grid") {
          const productField = this.addedProducts[rowIndex]?.ProductId;
          return product.ProductId == productField;
        } else {
          const productField = this.getFieldValue("ProductId",'middle');
          return product.ProductId == productField;
        }
      });
    }
  }
  
  export default ProductFilter;
  